"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAndValidateV1GetScoreList = exports.filterAndValidateLegacyV1GetScoreList = void 0;
const endpoints_1 = require("./endpoints");
const filterAndValidateLegacyV1GetScoreList = (scores, onParseError) => scores.reduce((acc, ts) => {
    const result = endpoints_1.GetScoreResponseDataV1.safeParse(ts);
    if (result.success) {
        acc.push(result.data);
    }
    else {
        console.error(`Score parsing error ${JSON.stringify(result.error)}`);
        onParseError?.(result.error);
    }
    return acc;
}, []);
exports.filterAndValidateLegacyV1GetScoreList = filterAndValidateLegacyV1GetScoreList;
/**
 * @deprecated
 * @alias
 * Use `filterAndValidateV2GetScoreList` instead. This function is only used for the legacy v1 API where scores were only associated with traces.
 * Use this function when pulling a list of scores from the database before returning to the public API to ensure type safety.
 * All scores are expected to pass the validation. If a score fails validation, it will be logged to Otel.
 * @param scores
 * @returns list of validated scores with trace information
 */
exports.filterAndValidateV1GetScoreList = exports.filterAndValidateLegacyV1GetScoreList;
